import React, { useState } from "react";
import { Container, Grid, Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  Image,
  LockClock,
  ManageAccounts,
  Password,
} from "@mui/icons-material";
import UserInfo from "./UserInfo";
import ChangePassword from "./ChangePassword";
import TwoFactorAuth from "./TwoFactorAuth";

const Settings = () => {
  const [tab, setTab] = useState("1");

  const handleTab = (event, value) => {
    setTab(value);
  };

  return (
    <>
      <Container>
        <Box>
          <Container maxWidth="md">
            <TabContext value={tab}>
              <Box sx={{ width: "100%" }}>
                <TabList
                  onChange={handleTab}
                  // variant="scrollable"
                  // scrollButtons="auto"
                  centered
                >
                  <Tab label="Profile" value="1" icon={<ManageAccounts />} />

                  <Tab label="password" value="2" icon={<Password />} />
                  <Tab label="2FA" value="3" icon={<LockClock />} />
                </TabList>
              </Box>
              <TabPanel value="1">
                <UserInfo />
              </TabPanel>

              <TabPanel value="2">
                <ChangePassword />
              </TabPanel>
              <TabPanel value="3">
                <TwoFactorAuth />
              </TabPanel>
            </TabContext>
          </Container>
        </Box>
      </Container>
    </>
  );
};

export default Settings;
